import { requestTimeout, handleResponse } from '../helpers'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

const base = 'collection'

const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem(accessToken),
})

export const collectionApi = {
    // Collection Methods
    _getMethods,
    _createMethod,
    _updateMethod,
    _deleteMethod,
    // Fee Tiers
    _getFeeTiers,
    _upsertFeeTier,
    _updateFeeTier,
    _deleteFeeTier,
    // Collection Accounts
    _getAccounts,
    _enrollAccount,
    _updateAccountStatus,
    _updateAccount,
    // Collection History
    _getHistory,
    // Settlements
    _getSettlements,
    _createSettlement,
}


// ─── Collection Methods ───────────────────────────────────────────────────────

async function _getMethods() {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/methods`, {
        method: 'GET',
        headers: authHeaders(),
    })).then(handleResponse)
}

async function _createMethod(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/methods`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _updateMethod(id, data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/methods/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _deleteMethod(id) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/methods/${id}`, {
        method: 'DELETE',
        headers: authHeaders(),
    })).then(handleResponse)
}


// ─── Fee Tiers ────────────────────────────────────────────────────────────────

async function _getFeeTiers(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/fee-tiers`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _upsertFeeTier(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/fee-tiers/upsert`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _updateFeeTier(id, data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/fee-tiers/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _deleteFeeTier(id) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/fee-tiers/${id}`, {
        method: 'DELETE',
        headers: authHeaders(),
    })).then(handleResponse)
}


// ─── Collection Accounts ──────────────────────────────────────────────────────

async function _getAccounts(clientId = null, search = null, page = 1, pageSize = 50) {
    const params = new URLSearchParams()
    if (clientId) params.append('client_id', clientId)
    if (search) params.append('search', search)
    params.append('page', page)
    params.append('page_size', pageSize)
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/accounts?${params.toString()}`, {
        method: 'GET',
        headers: authHeaders(),
    })).then(handleResponse)
}

async function _enrollAccount(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/accounts`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

// ─── Collection History ───────────────────────────────────────────────────────

async function _getHistory(data = {}, page = 1, pageSize = 50) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/history`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ ...data, page, page_size: pageSize }),
    })).then(handleResponse)
}


// ─── Collection Accounts ──────────────────────────────────────────────────────

// ─── Settlements ──────────────────────────────────────────────────────────────

async function _getSettlements(data = {}, page = 1, pageSize = 50) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/settlements`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ ...data, page, page_size: pageSize }),
    })).then(handleResponse)
}

async function _createSettlement(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/settle`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}


async function _updateAccountStatus(id, status) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/accounts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify({ status }),
    })).then(handleResponse)
}

async function _updateAccount(id, data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `${base}/accounts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}
